import { render, staticRenderFns } from "./AboutPageAdvantagesBlock.vue?vue&type=template&id=f821651e&scoped=true&"
import script from "./AboutPageAdvantagesBlock.vue?vue&type=script&lang=js&"
export * from "./AboutPageAdvantagesBlock.vue?vue&type=script&lang=js&"
import style0 from "./AboutPageAdvantagesBlock.vue?vue&type=style&index=0&id=f821651e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f821651e",
  null
  
)

export default component.exports